import { biLogger } from 'hooks/biLogger/biLogger';
import { BI_CONSTANTS } from 'hooks/biLogger/biConstants';

type PostPurchaseStepId = 'storefront' | 'domain' | 'setup';

const { ACTION, BUTTON_NAME } = BI_CONSTANTS;

export const postPurchaseBi = {
  stepSelect(stepId: PostPurchaseStepId) {
    biLogger.actionClicked({
      action: ACTION.POST_PURCHASE_STEP_SELECT,
      button_name: BUTTON_NAME.SELECT,
      value: stepId,
    });
  },

  stepOpen(stepId: PostPurchaseStepId) {
    biLogger.actionClicked({
      action: ACTION.POST_PURCHASE_STEP_OPEN,
      button_name: BUTTON_NAME.GO,
      value: stepId,
    });
  },

  stepClose(stepId: PostPurchaseStepId) {
    biLogger.actionClicked({
      action: ACTION.POST_PURCHASE_STEP_CLOSE,
      button_name: BUTTON_NAME.CLOSE,
      value: stepId,
    });
  },

  siteLinkClick() {
    biLogger.actionClicked({
      action: ACTION.POST_PURCHASE_SITE_LINK,
      button_name: BUTTON_NAME.SITE_URL,
    });
  },

  connectDomain(domain: string) {
    biLogger.actionClicked({
      action: ACTION.POST_PURCHASE_CONNECT_DOMAIN,
      button_name: BUTTON_NAME.CONNECT_DOMAIN,
      value: domain,
    });
  },

  connectPayments() {
    biLogger.actionClicked({
      action: ACTION.POST_PURCHASE_CONNECT_PAYMENTS,
      button_name: BUTTON_NAME.CONNECT_PAYMENTS,
    });
  },

  wixAppLink(provider: 'apple' | 'google') {
    biLogger.actionClicked({
      action: ACTION.POST_PURCHASE_WIX_APP_LINK,
      button_name: BUTTON_NAME.WIX_APP,
      value: provider,
    });
  },

  courseClick(brandName: string) {
    biLogger.actionClicked({
      action: ACTION.POST_PURCHASE_COURSE,
      button_name: BUTTON_NAME.COMPLETE_COURSE,
      value: brandName,
    });
  },

  accessDeniedCta() {
    biLogger.actionClicked({
      action: ACTION.POST_PURCHASE_ACCESS_DENIED,
      button_name: BUTTON_NAME.GO_TO_WIX,
    });
  },
};
